import { render, staticRenderFns } from "./TermsAndPrivacyPage.vue?vue&type=template&id=0635b9e2&"
import script from "./TermsAndPrivacyPage.vue?vue&type=script&lang=js&"
export * from "./TermsAndPrivacyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports